import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

/**
 * BarcodePreview — rendert een EAN/Code128 barcode als SVG.
 *
 * Props:
 *  - value (string)  : de code om te renderen
 *  - format (string) : EAN13 | CODE128 | … (default auto: EAN13 bij 13 digits, anders CODE128)
 *  - height (number) : default 48
 *  - displayValue (bool) : toon de code onder de streepjes (default true)
 */
export default function BarcodePreview({ value, format, height = 48, displayValue = true, className = '' }) {
  const ref = useRef(null);
  const v = (value || '').toString().trim();

  useEffect(() => {
    if (!ref.current || !v) return;
    let fmt = format;
    if (!fmt) fmt = /^\d{13}$/.test(v) ? 'EAN13' : (/^\d{8}$/.test(v) ? 'EAN8' : 'CODE128');
    try {
      JsBarcode(ref.current, v, {
        format: fmt,
        height,
        width: 1.6,
        margin: 4,
        displayValue,
        fontSize: 11,
        textMargin: 2,
        background: '#ffffff',
        lineColor: '#0b1020',
      });
    } catch (e) {
      // Ongeldige input (b.v. EAN-13 met verkeerde checksum) — toon fallback
      if (ref.current) ref.current.innerHTML = '';
    }
  }, [v, format, height, displayValue]);

  if (!v) return null;
  return <svg ref={ref} className={className} data-testid="barcode-preview" />;
}
